import * as React from "react"
import styled from "styled-components"
import { HorizontalSpacer } from "../../atoms/spacers"
import H3 from "../../atoms/typography/H3"
import H4 from "../../atoms/typography/H4"
import PrimaryButton from "../../atoms/buttons/PrimaryButton"

interface Props {
  groupName: string
  onClose: () => void
  onClickRemoveGroup: () => void
}

const ContentContainer = styled.div`
  padding: ${(props) => `${props.theme.spacings.large} ${props.theme.spacings.larger}`};
`

const ActionButtonContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`

const DeleteGroupWarningModalContent: React.FunctionComponent<Props> = ({ groupName, onClose, onClickRemoveGroup }) => {
  return (
    <ContentContainer>
      <H4 textAlign="center">Are you sure you want to delete the group {groupName}?</H4>
      <HorizontalSpacer spacing={2} />
      <H3 textAlign="center">
        You will no longer have access to this group. All group content will be deleted. This action cannot be undone.
      </H3>
      <HorizontalSpacer spacing={3} />
      <ActionButtonContainer>
        <PrimaryButton title="Delete group" onClick={onClickRemoveGroup} destructive />
        <PrimaryButton title="Don't delete group" onClick={onClose} />
      </ActionButtonContainer>
    </ContentContainer>
  )
}

export default DeleteGroupWarningModalContent
